import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Centro from "@/components/Centro";
import Hours from "@/components/Hours";
import Contact from "@/components/Contact";
import FinalCTA from "@/components/FinalCTA";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Services />
      <Centro />
      <Hours />
      <Contact />
      <FinalCTA />
    </>
  );
}
